/* eslint-disable no-case-declarations */
export default function insights({ from, to, next, hook }) {
  switch (hook) {
    case 'before':
      if (window.appInsights) {
        const toRouteName = to.name;
        if (toRouteName) {
          window.appInsights.startTrackPage(toRouteName);
        }
      }

      next();
      break;
    case 'after':
      if (window.appInsights && from) {
        const fromRouteName = from.name;
        if (fromRouteName) {
          const fullPath = `${location.protocol}//${location.host}${from.fullPath}`;
          window.appInsights.stopTrackPage(fromRouteName, fullPath);
          window.appInsights.flush();
        }
      }
      break;
    default:
      next();
      break;
  }
}




// WEBPACK FOOTER //
// ./src/router/middlewares/insights.js